export const getFileExtension = (name: string): string => {
  const exts = name.match(/\.[0-9a-z]+$/i);
  if (exts && exts.length > 0) return exts[0];

  return '';
};

export const ZIP_FILE_MIME_TYPES = ['application/zip', 'application/x-zip-compressed'];

export const FILENAME_FORBIDDEN_CHARACTERS = '<>:"/\\|?*';

export const FLOORPLAN_IMPORT_ACCEPTABLE_TYPES = ['json', 'zip', ...ZIP_FILE_MIME_TYPES];

export const isZipFile = (file: File): boolean =>
  ZIP_FILE_MIME_TYPES.includes(file.type) || getFileExtension(file.name).toLowerCase() === '.zip';

export const isObject = (value: unknown): value is object =>
  typeof value === 'object' && value !== null;
